/**
 * Test ID utilities for Textarea component
 *
 * Pattern: All test IDs are generated via named setter functions.
 * This ensures consistency between components and tests.
 */

import { generateTestId } from "@client-shared";

/**
 * Generate test ID for textarea elements
 * @param identifier - Textarea identifier (name, placeholder, or 'unnamed')
 * @returns Test ID string
 */
export const setTextareaTestId = (identifier: string): string =>
  generateTestId("Textarea", identifier.replace(/\s+/g, "-").toLowerCase());
